import React from "react";
import { Container } from "react-bootstrap";

import { FaHeart } from "react-icons/fa";

function Footer() {
  return (
    <Container fluid className="footer">
      <div className="footer-div">
        <p className="footer-text" style={{ color: "white" }}>
          Made with <FaHeart color="red" /> by Sumanth Nandeti
        </p>
      </div>
    </Container>
  );
}

export default Footer;
